// Angular Dependencies
import { NgModule } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { ModalHtmlPreviewComponent } from "./modal-html-preview.component";

@NgModule({
	declarations: [ModalHtmlPreviewComponent],
	imports: [
    MatIconModule
	],
	exports: [ModalHtmlPreviewComponent],
})
export class ModalHtmlPreviewModule {}
